import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomHighChartComponent from "../../../../../shared/custom-highchart-component/custom-highchart.component";
import CustomSpinnerComponent from "../../../../../shared/custom-spinner/custom-spinner.component";
import { getDaylightReadingData } from "../../../../../store/slices/asset.slice";
import { generateFilenameWithTimestamp } from "src/shared/helpers/generateFilenameWithTimestamp";

interface AssetDetailsDaylightReadingChartType {
  assetId: any;
  isRefreshed: boolean;
}

const AssetDetailsDaylightReadingChart: FC<
  AssetDetailsDaylightReadingChartType
> = ({ assetId, isRefreshed }) => {
  const dispatch = useDispatch();
  const [daylightReadingData, setDaylightReadingData] = useState<any>({});

  useEffect(() => {
    dispatch(getDaylightReadingData({ id: assetId }));
  }, [assetId, isRefreshed]);

  const isLoadingDaylightReadingChartData = useSelector((state: any) => {
    return state.asset.isLoadingDaylightReadingChartData;
  });

  const daylightReadingChartData = useSelector((state: any) => {
    return state.asset.daylightReadingChartData;
  });

  useEffect(() => {
    if (daylightReadingChartData?.data?.length) {
      const hour = daylightReadingChartData?.data?.map((d: any) => d?.hour);

      const sensorReading = daylightReadingChartData?.data?.every(
        (d: any) => d?.sensorReading == null
      )
        ? null
        : daylightReadingChartData?.data?.map((d: any) => d?.sensorReading);

      setDaylightReadingData({
        sensorReading,
        hour,
      });
    } else {
      setDaylightReadingData({
        sensorReading: [],
        hour: [],
      });
    }
  }, [daylightReadingChartData]);

  const daylightReadingChartToolTipFormatter = (point: any) => {
    const { x, y } = point;

    const time =
      daylightReadingData?.hour?.[point.index] || point.category || x;
    return `<b>Time (Hour): </b> ${time}<br/>
            <b>Daylight Reading (Lux): </b> ${y} <br/>`;
  };

  return (
    <div className="mt-4 ">
      <div>
        <h4 className="h4" style={{ marginBottom: "1rem" }}>
          Daylight <span style={{ fontSize: "16px" }}>(Last Day)</span>
        </h4>
      </div>

      <CustomSpinnerComponent
        height={"300px"}
        width={"100%"}
        isLoading={isLoadingDaylightReadingChartData}
      >
        <CustomHighChartComponent
          xAxisCategories={daylightReadingData?.hour}
          SeriesType={"spline"}
          seriesData={daylightReadingData?.sensorReading}
          seriesShowInLegend={false}
          seriesName={"Daylight Reading"}
          xAxisTitleText={"Time (Hour)"}
          yAxisTitleText={"Daylight Reading(Lux)"}
          colors={["#66b2ff"]}
          fileName={generateFilenameWithTimestamp(
            "Daylight Reading (Last Day)"
          )}
          chartName={"Daylight Reading (Last Day)"}
          tooltipFormatter={daylightReadingChartToolTipFormatter}
        />
      </CustomSpinnerComponent>
    </div>
  );
};

export default AssetDetailsDaylightReadingChart;
